/**
 * Format an annual INR salary range as "₹X.X - ₹Y.Y LPA"
 * (LPA = Lakhs Per Annum, the standard Indian salary unit).
 *
 * - >= 1,00,000 (1 lakh) → display in lakhs, "LPA"
 * - <  1,00,000          → display in thousands, "K /yr"
 * - missing both         → "Competitive"
 */
const formatLakh = (n) => {
    const lakhs = n / 100000;
    return Number.isInteger(lakhs) ? `${lakhs}` : lakhs.toFixed(1);
};

const formatThousand = (n) => `${Math.round(n / 1000)}K`;

export const formatSalaryINR = (min, max) => {
    if (!min && !max) return "Competitive";
    const useLakhs = (min || max) >= 100000;
    if (min && max) {
        return useLakhs
            ? `₹${formatLakh(min)} - ₹${formatLakh(max)} LPA`
            : `₹${formatThousand(min)} - ₹${formatThousand(max)} /yr`;
    }
    if (min) {
        return useLakhs ? `from ₹${formatLakh(min)} LPA` : `from ₹${formatThousand(min)} /yr`;
    }
    return useLakhs ? `up to ₹${formatLakh(max)} LPA` : `up to ₹${formatThousand(max)} /yr`;
};
